import "reflect-metadata";
import { inject, injectable } from "inversify";
import { Logger } from "pino";
import { RouteParameterNames, RoutePathNames } from "~/app/router.options";
import { INJECT_SYMBOLS } from "~/service/inversion-of-control/inject-symbols";
import { RouteLocationNormalizedLoaded } from "../../../../../.nuxt/vue-router";
import { IBreadcrumbsHandler } from "../handlers";
import { BreadcrumbsLink } from "../../lib/types";
import { IBreadcrumbsController } from "./types";

@injectable()
export class BreadcrumbsController implements IBreadcrumbsController {
  constructor(
    @inject(INJECT_SYMBOLS.Logger)
    private readonly _logger: Logger,
    @inject(INJECT_SYMBOLS.BreadcrumbsCollectiontHandler)
    private readonly _collectionHandler: IBreadcrumbsHandler,
  ) {}

  handle(route: RouteLocationNormalizedLoaded): BreadcrumbsLink[] | false {
    try {
      if (route.name === RoutePathNames.HOME) return false;

      if (route.params[RouteParameterNames.COLLECTION_NAME]) {
        return this._collectionHandler.handleBreadcrumbs(route);
      }
      return false;
    } catch (error) {
      this._logger.error({ error, route }, `[BreadcrumbsController]: onHandle error`);
      return false;
    }
  }
}
